"use client";

import React from "react";
import { Dialog, Modal } from "staysure-component-library";

import { useRenewalPaymentSummaryStateContext } from "@/providers/renewal-payment-summary-auto-pay-state-provider";
import { CardholderCosentModalType } from "@/schema/renewal-page/payment-summary-page.schema";

import CardholderConsentModalContent from "./modal-content/cardholder-consent-modal-content";

type RenewalCardholderConsentModalType = {
  handleContinue?: () => void;
};

function CardholderConsentModal(
  props: Readonly<CardholderCosentModalType & RenewalCardholderConsentModalType>
) {
  const { isOpenCardholderConsentModal, setIsOpenCardholderConsentModal } =
    useRenewalPaymentSummaryStateContext();
  return (
    <Modal
      modalStyles={{
        top: `50%`,
        left: `50%`,
        transform: `translate(-50%, -50%)`,
      }}
      className="bg-surface-neutral-option-1 rounded-lg  relative w-fit h-fit"
      uderlayClassName="z-[101] bg-interactive-overlay-default"
      isOpen={isOpenCardholderConsentModal}
      isDismissable={false}
      onOpenChange={(value: boolean) => {
        if (setIsOpenCardholderConsentModal)
          setIsOpenCardholderConsentModal(value);
      }}
    >
      <Dialog className="relative gap-spacing-l">
        <CardholderConsentModalContent
          onCancel={() => {
            if (setIsOpenCardholderConsentModal)
              setIsOpenCardholderConsentModal(false);
          }}
          // eslint-disable-next-line react/jsx-props-no-spreading
          {...props}
        />
      </Dialog>
    </Modal>
  );
}

export default CardholderConsentModal;
